import Link from 'components/Link';
import classNames from 'styles/utils/classNames';
import {
  PRICING_PAGE,
  OPC_PAGE,
  MASTER_CLASS_ARTICLE_PAGE,
  HOME_PAGE,
  OPTION_FLOW_PAGE,
  LOGIN_PAGE,
  SIGNUP_PAGE,
} from 'constants/pages';

const NAVIGATION_ITEMS = [
  { name: 'Home', href: HOME_PAGE, current: false },
  { name: 'Pricing', href: PRICING_PAGE, current: false },
  { name: 'Free OPC', href: OPC_PAGE, current: false },
  { name: 'Free Masterclass', href: MASTER_CLASS_ARTICLE_PAGE, current: false },
  { name: 'Free Options Flow', href: OPTION_FLOW_PAGE, current: false },
];

export default function TopNavThin() {
  return (
    <>
      <div className="hidden h-12 w-full items-center justify-between border-b border-palette-border px-2 pl-[60px] md:flex">
        <div>&nbsp;</div>
        <div className="flex items-center gap-6">
          {NAVIGATION_ITEMS.map((item) => (
            <Link key={item.name} href={item.href} className={classNames('text-xs font-semibold')}>
              {item.name}
            </Link>
          ))}
        </div>
        <div className="flex items-center gap-4">
          <Link href={LOGIN_PAGE} className="text-xs font-semibold">
            Log in
          </Link>
          <Link
            href={SIGNUP_PAGE}
            className="rounded bg-brand-green-secondary px-2 py-1 text-center text-xs font-semibold"
          >
            Get Started
          </Link>
        </div>
      </div>
    </>
  );
}
